import React, { FC } from 'react';
import styles from './ArticleItem.css';
import { cropText, replaceNBSP } from '../utils/formatHelper';

export interface IArticle {
  title: string;
  imageUrl: string;
  url: string;
}

const MAX_SUBTITLE = 85;
const MAX_TITLE = 85;

export interface IArticleItem extends IArticle {
  caption: string;
}

export const ArticleItem: FC<IArticleItem> = ({ imageUrl, title, caption, url }) => {
  return (
    <a href={url} className={styles['articles-item-link']}>
      <div className={styles['articles-item']}>
        <div>
          <div className={styles['articles-title']}>{cropText(title, MAX_TITLE)}</div>
          <div className={styles['articles-caption']}>{replaceNBSP(cropText(caption, MAX_SUBTITLE))}</div>
        </div>
        <img
          className={styles['articles-image']}
          style={{
            backgroundImage: `url(${imageUrl})`,
          }}
        />
      </div>
    </a>
  );
};
